<template>
    <div style="direction:rtl">
        <CCard>
            <CCardHeader>
                <h3 class="card-title">کراپ  نقشه</h3>
            </CCardHeader>
            <CCardBody>
                <div style="display:flex;height:65vh;gap:10px">
                    <div style="width:50%;height:65vh;">
                        <l-map  use-global-leaflet  style="width:100%;height:100%;direction:ltr" :zoom="zoom" :center="center" ref="map" @ready="onLeafletReady" >
                            <l-tile-layer :url="url"></l-tile-layer>
                            <l-wms-tile-layer
                              :key="wmsLayer.name"
                              :base-url="wmsLayer.url"
                              :layers="wmsLayer.layers"
                              :visible="wmsLayer.visible"
                              :name="wmsLayer.name"
                              :attribution="wmsLayer.attribution"
                              :transparent="true"
                              format="image/png"
                              layer-type="base">
                            </l-wms-tile-layer>
                            <l-draw-toolbar ref="draw" position="topright"/>

                        </l-map>
                    </div>
                    <div style="width:100%;height:65vh;max-width:50%;">
                        <div>
                            <CTabs >
                            <CTab title="خطوط" active>
                                
                                <CDataTable
                                    :hover="true"
                                    :border="true"
                                    :striped="true"
                                    :small="true"
                                    :items="$store.state.BusLines_GetByCrop.RequestResponse"
                                    :fields="fields1"
                                    :fixed="true"
                                    :clickableRows="true"
                                    :items-per-page="5"
                                    pagination
                                    style="overflow: hidden;margin-top:10px"
                                    >
                                    <template #Rows="{item,index}">
                                        <td style="direction: ltr">
                                            {{index+1 }}
                                        </td>
                                    </template>
                                </CDataTable>
                            </CTab>
                            <CTab title="ایستگاه ها" >
                                <CDataTable
                                    :hover="true"
                                    :border="true"
                                    
                                    :striped="true"
                                    :small="true"
                                    :items="$store.state.Station_GetByCrop.RequestResponse"
                                    :fields="fields2"
                                    :fixed="true"
                                    :clickableRows="true"
                                    :items-per-page="5"
                                    pagination
                                    style="overflow: hidden;margin-top:10px"
                                    >
                                     <template #Rows="{item,index}">
                                        <td style="direction: ltr">
                                            {{index+1 }}
                                        </td>
                                    </template>



                                </CDataTable>
                            </CTab>
                            <CTab title="خودرو ها" >
                                <CDataTable
                                    :hover="true"
                                    :border="true"
                                    :striped="true"
                                    :small="true"
                                    :items="$store.state.Device_GetByCrop.RequestResponse"
                                    :fields="fields"
                                    :fixed="true"
                                    :clickableRows="true"
                                    :items-per-page="5"
                                    pagination
                                    style="overflow: hidden;margin-top:10px"
                                    >
                                    <template #Rows="{index}">
                                        <td style="direction: ltr">
                                            {{index+1 }}
                                        </td>
                                    </template>
                                     


                                </CDataTable>
                            </CTab>
                        </CTabs>
                        </div>

                    </div>
                    
                </div>
            </CCardBody>
        </CCard>
    </div>
</template>

<script>
    export default {
        name: "Pages",
        data(){
            return {
                url: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
                zoom: 5,
                center: [29.582689, 52.584419],
                fields1:[{key:'Rows',label:'ردیف'},{key:'LineName',label:'نام خط'}],
                fields2:[{key:'Rows',label:'ردیف'},{key:'StationName',label:'نام ایستگاه'},{key:'StationCode',label:'کد ایستگاه'},{key:'LineName',label:'نام خط'}],
                fields:[{key:'Rows',label:'ردیف'},{key:'CurrVehicleName',label:'نام خودرو'}],
                 wmsLayer: {
                    url: 'https://gis.shiraz.ir/shirazgis/gis_workspace/wms?',
                    name: 'Weather Data',
                    visible: true,
                    format: 'image/png',
                    layers: 'regionwms',
                    transparent: true,
                    attribution: 'Weather data &copy; 2012 <a href="https://mesonet.agron.iastate.edu/docs/nexrad_mosaic/">IEM Nexrad</a>',
                },
            }
        },
        computed:{

        },
        watch:{

        },
        mounted(){
            this.url=Constant.MapUrl;
        },
        methods:{
            async onLeafletReady() {
            await this.$nextTick();
            this.$refs.map.mapObject.on(L.Draw.Event.CREATED, (e) => {
                const type = e.layerType;
                if (type === 'rectangle') {
                   this.BusLines_GetByCrop(e.layer.getLatLngs())
                   this.Station_GetByCrop(e.layer.getLatLngs())
                   this.Device_GetByCrop(e.layer.getLatLngs())
                } 
                console.log(this.$refs.draw)
            });
            },
            getDrawConfiguration(editableLayers) {
                return {
                    position: 'topright',
                    draw: {
                        polygon: {
                            allowIntersection: false, // Restricts shapes to simple polygons
                            drawError: {
                                color: '#e1e100', // Color the shape will turn when intersects
                                message: '<strong>Oh snap!<strong> you can\'t draw that!' // Message that will show when intersect
                            },
                            shapeOptions: {
                                color: '#97009c'
                            }
                        },
                        // disable toolbar item by setting it to false
                        polyline: false,
                        circle: false,
                        circleMarker: false,
                        rectangle: false,
                        marker: false,
                    },
                    edit: {
                        featureGroup: editableLayers,
                        remove: false
                    }
                };
            },//BusLines_GetByCrop
            BusLines_GetByCrop(data){
                console.log(data[0])
                console.log(data[0])
                this.$store.commit('BusLines_GetByCrop',{
                    UserID:2188,
                    Lat1:data[0][0].lat,
                    Lng1:data[0][0].lng,
                    Lat2:data[0][2].lat,
                    Lng2:data[0][2].lng,
                });
            },
            Station_GetByCrop(data){
                console.log(data[0])
                console.log(data[0])
                this.$store.commit('Station_GetByCrop',{
                    UserID:2188,
                    Lat1:data[0][0].lat,
                    Lng1:data[0][0].lng,
                    Lat2:data[0][2].lat,
                    Lng2:data[0][2].lng,
                });
            },
            Station_GetByCrop(data){
                console.log(data[0])
                console.log(data[0])
                this.$store.commit('Station_GetByCrop',{
                    UserID:2188,
                    Lat1:data[0][0].lat,
                    Lng1:data[0][0].lng,
                    Lat2:data[0][2].lat,
                    Lng2:data[0][2].lng,
                });
            },
            Device_GetByCrop(data){
                console.log(data[0])
                console.log(data[0])
                this.$store.commit('Device_GetByCrop',{
                    UserID:2188,
                    Lat1:data[0][0].lat,
                    Lng1:data[0][0].lng,
                    Lat2:data[0][2].lat,
                    Lng2:data[0][2].lng,
                });
            },
        }
    }
</script>

<style scoped>

</style>